// extracted by mini-css-extract-plugin
export default {"title":"_3120238c9e","bld":"_44ba8d9054"};